export const labelStyles = { display: 'inline-flex', alignItems: 'center', gap: '4px' };

export const breakdownStyles = { display: 'flex', flexDirection: 'column', gap: '4px' };

// No color literal: the row text inherits the MUI Tooltip's theme-aware color, which flips
// correctly between light and dark modes.
export const rowStyles = { display: 'flex', justifyContent: 'space-between', gap: '16px' };
